export default __webpack_public_path__ + "static/media/olx-group.7aa82773.svg";